const state = () => ({
  categoryTypes: [],
});

const getters = {
  all: state => state.categoryTypes.reduce((acc, type) => {
    acc[type.id] = type;
    return acc;
  }, {}),
  attachmentCategoryTypes: state => state.categoryTypes.filter(t => t.name.includes('attachment')),
  categoryTypes: state => state.categoryTypes,
  groupingCategoryTypes: state => state.categoryTypes.filter(t => t.name.includes('grouping')),
  icsCategoryTypes: state => state.categoryTypes.filter(t => t.name.includes('topic-interactive-case-study')),
  multipleChoiceCategoryTypes: state => state.categoryTypes.filter(t => t.name.includes('multiple-choice')),
  mnemonicCategoryTypes: state => state.categoryTypes.filter(t => t.name.includes('mnemonic')),
  quizCategoryTypes: state => state.categoryTypes.filter(t => t.name.includes('quiz')),
  terminologyCategoryTypes: state => state.categoryTypes.filter(t => t.name.includes('terminology')),
  testSimulationCategoryTypes: state => state.categoryTypes.filter(t => t.name.includes('test-simulation')),
  topicCategoryTypes: state => state.categoryTypes.filter(t => t.name.includes('topic')),
  userQuizCategoryType: state => state.categoryTypes.find(t => t.name.includes('user-quiz')),
  webDiagnosticCategoryTypes: state => state.categoryTypes.filter(t => t.name.includes('web-app-diagnostic')),
  webPageCategoryTypes: state => state.categoryTypes.filter(t => t.name.includes('web-page')),
};

const mutations = {
  setCategoryTypes(state, types) {
    state.categoryTypes = types;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
};
